<template>
    <div>
        <b-navbar toggleable="lg" type="dark" style="background-color: #00717c" sticky>
            <b-navbar-brand href="//www.studiesweekly.com/" target="_blank">
                <img src="https://cdn.studiesweekly.com/logo/2017+SW_horiz-white.png" alt="Studies Weekly" class="d-inline-block align-top" style="max-height: 30px"  />
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">
                <b-btn href="https://www.studiesweekly.com/south-dakota/" target="_blank" size="sm" variant="success">See More South Dakota Curricula</b-btn>
            </b-navbar-nav>
        </b-navbar>


        <b-container class="my-5" v-show="!invoiceId">


            <!-- Form / Main Page -->
            <div>

<!--                Single Year<b-form-checkbox switch v-model="multiyear"></b-form-checkbox>6 Year-->

                <!-- Step Indicator -->
                <div class="mb-4">
                    <div>
                        <b-btn pill class="mr-3" :variant="getStepVariant(0)" @click="setStep(0)">
                            <span class="d-none d-md-inline">Enter</span> Password
                            <span class="pill-validator" ref="step0_invalid"><font-awesome-icon :icon="['fas','exclamation']"/></span>
                            <span v-if="stepsValid[0]"><font-awesome-icon :icon="['fas','check']"/></span>
                        </b-btn>
                        <b-btn pill class="mr-3" :variant="getStepVariant(1)" @click="setStep(1)">
                            <span class="d-none d-md-inline">Select</span> District
                            <span class="pill-validator"  ref="step1_invalid"><font-awesome-icon :icon="['fas','exclamation']"/></span>
                            <span v-if="stepsValid[1]"><font-awesome-icon :icon="['fas','check']"/></span>
                        </b-btn>
                        <b-btn pill class="mr-3" :variant="getStepVariant(2)" @click="setStep(2)">
                            <span class="d-none d-md-inline">Enter</span> Contacts
                            <span class="pill-validator"  ref="step2_invalid"><font-awesome-icon :icon="['fas','exclamation']"/></span>
                            <span v-if="stepsValid[2]"><font-awesome-icon :icon="['fas','check']"/></span>
                        </b-btn>
                        <b-btn pill class="mr-3" :variant="getStepVariant(3)" @click="setStep(3)">
                            <span class="d-none d-md-inline">Select</span> Publications
                            <span class="pill-validator"  ref="step3_invalid"><font-awesome-icon :icon="['fas','exclamation']"/></span>
                            <span v-if="stepsValid[3]"><font-awesome-icon :icon="['fas','check']"/></span>
                        </b-btn>
                        <b-btn pill class="mr-3" :variant="getStepVariant(4)" @click="setStep(4)">
                            <span class="d-none d-md-inline">Review & </span>Submit
                        </b-btn>
                    </div>
                </div>

                <!-- Password FORM -->
                <b-form v-show="shouldShowStep(0)" @submit.prevent="goToNextStep()">

                    <!-- STATE PASSWORD -->
                    <span v-if="!stepsValid[0]" class="text-danger">{{password_message}}</span>
                    <b-input-group prepend="State Password" class="mb-4">
                        <b-input :disabled="stepsValid[0]" name="state_password" v-model="password" placeholder="Enter Password Here" required></b-input>
                        <div class="loader" style="width: 25px; height: 25px" v-if="validatingPassword"></div>
                    </b-input-group>



                    <!-- Step Buttons -->
                    <div class="mt-4">
                        <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                            <b-button-group class="ml-auto mx-1">
                                <b-btn v-if="!isPasswordChecked || !stepsValid[0]" variant="success" type="submit" @click="checkPassword()">Check Password</b-btn>
                                <b-btn v-else variant="primary" type="submit">Next &rsaquo;</b-btn>
                            </b-button-group>
                        </b-button-toolbar>
                    </div>
                </b-form>

                <!-- District Select Box -->
                <b-form v-show="shouldShowStep(1)" @submit.prevent="goToNextStep()">
                    <!-- SELECT BOX -->
                    <b-row>
                        <b-col>
                        <b-form-group class="p-0">
                            <h3 for="district">School Districts</h3>
                            <multiselect id="district"
                                         v-model="selectedDistrict"
                                         :options="districts"
                                         label="name"
                                         track-by="id"
                                         placeholder="Select Option"
                                         :searchable="true"
                                         :multiple="false"
                            >
                            </multiselect>
                        </b-form-group>
                        </b-col>
                        <b-col>
                        <b-form-group class="p-0">
                            <h3 for="private">Non-Public School:</h3>
                            <multiselect id="private"
                                         v-model="selectedPrivate"
                                         :options="privates"
                                         label="name"
                                         track-by="id"
                                         placeholder="Select Option"
                                         :searchable="true"
                                         :multiple="false"
                            >
                            </multiselect>
                        </b-form-group>
                        </b-col>
                    </b-row>
                    <!-- INFO DISPLAY -->
                    <b-container id="district_info" ref="form" class="pb-2" v-if="selectedCompany">
                        <b-row>
                            <b-form-group label="Shipping Address">
                                <b-input size="sm" type="text" name="street" v-model="selectedCompany.shipping_address" required></b-input>
                            </b-form-group>
                            <b-form-group label="Zip code">
                                <b-input size="sm" type="text" name="zip" v-model="selectedCompany.zip" required></b-input>
                            </b-form-group>
                        </b-row>

                        <b-row>
                            <b-form-group label="City">
                                <b-input size="sm" type="text" name="city" v-model="selectedCompany.city" required></b-input>
                            </b-form-group>
                            <b-form-group label="State">
                                <b-input size="sm" type="text" name="state" value="SD" required disabled></b-input>
                            </b-form-group>
                        </b-row>

                        <b-row>
                            <b-col class="mt-3">
                                <div ref="blackoutWindow">Select date ranges that you are <strong style="color: red;">NOT</strong> available to receive shipment</div>
                                <div class="mt-2"><b-checkbox id="blackout_none" v-model="blackoutNoWindows" name="blackoutNoWindows">I can receive shipment at any time</b-checkbox></div>
                                <!-- Blackout Window -->
                                <div v-show="!blackoutNoWindows">
                                    <div v-for="(blackoutWindow, i) in blackoutWindows" :key="`window_${i}`">
                                        <v-date-picker
                                            class="mt-1"
                                            mode="range"
                                            is-range
                                            color="purple"
                                            v-model="blackoutWindows[i]"
                                            :disabled-dates="getDisabledDates(i)"
                                            :columns="$screens({ default: 1, lg: 2 })"
                                            :rows="$screens({ default: 2, lg: 1 })"
                                            show-caps
                                            is-inline
                                            is-double-paned
                                            @input="validateRange($event, i)"
                                            :ref="`blackoutWindow_${i}`"
                                        />
                                        <b-input-group
                                            class="mt-1 w-75 date-label"
                                            @click="toggleWindow(i)"
                                        >
                                            <template #prepend>
                                                <b-input-group-text><font-awesome-icon :icon="['fas','calendar-times']"></font-awesome-icon></b-input-group-text>
                                            </template>
                                            <b-form-input
                                                type="text"
                                                class="date-label"
                                                :value="dateRangeText(blackoutWindows[i])"

                                                readonly
                                            ></b-form-input>
                                            <template #append>
                                                <b-button type="link" variant="danger" size="sm" @click="deleteWindow(i)">
                                                    <font-awesome-icon :icon="['fas','trash-alt']"></font-awesome-icon>
                                                </b-button>
                                            </template>
                                        </b-input-group>
                                    </div>
                                    <div class="text-danger">{{arriveWindowRangeError}}</div>
                                    <b-button type="button"
                                              size="sm"
                                              variant="success"
                                              @click="addWindow()"
                                              :disabled="blackoutWindows.length >= 5"
                                              class="mt-3">
                                        Add Date Range
                                    </b-button>
                                </div>

                            </b-col>
                        </b-row>
                    </b-container>
                    <!-- Step Buttons -->
                    <div class="mt-4">
                        <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                            <b-button-group class="mx-1">
                                <b-btn @click="currentStep--">&lsaquo; Previous</b-btn>
                            </b-button-group>
                            <b-button-group class="ml-auto mx-1">
                                <b-btn type="submit" variant="primary">Next &rsaquo;</b-btn>
                            </b-button-group>
                        </b-button-toolbar>
                    </div>
                </b-form>

                <!-- CONTACT FORMS -->
                <b-form  v-show="shouldShowStep(2)" @submit.prevent="goToNextStep()">
                    <div id="contact_collapse" visible>
                        <b-row>
                        <b-col>
                            <b-card bg-variant="light" class="my-2">
                                <h4>Main Order Contact</h4>
                                <b-form-group
                                    label-cols-lg="3"
                                    :label="contacts[0].position"
                                    label-class="font-weight-bold pt-0"
                                    class="mb-0"
                                >
                                    <b-form-group
                                        label="First Name:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-input name="first_name" v-model="contacts[0].first_name" required></b-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Last Name:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-input name="last_name" v-model="contacts[0].last_name" required></b-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Email:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-input name="email" v-model="contacts[0].email" required></b-input>
                                    </b-form-group>
                                    <b-form-group
                                        label="Phone:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-input name="phone" v-model="contacts[0].phone" :formatter="phoneFormatter" required></b-input>
                                    </b-form-group>
                                    <b-form-group
                                        label="Job Title:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-input name="title" v-model="contacts[0].title"></b-input>
                                    </b-form-group>
                                </b-form-group>
                            </b-card>
                        </b-col>
                        <b-col>
                            <b-card bg-variant="light" class="my-2">
                                <h4>Secondary <span class="d-none d-md-inline">Order</span> Contact</h4>
                                <b-form-group
                                    label-cols-lg="3"
                                    :label="contacts[1].position"
                                    label-size="lg"
                                    label-class="font-weight-bold pt-0"
                                    class="mb-0"
                                >
                                    <b-form-group
                                        label="First Name:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-form-input name="first_name" v-model="contacts[1].first_name" required></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Last Name:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-form-input name="last_name" v-model="contacts[1].last_name" required></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Email:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-form-input name="email" v-model="contacts[1].email" required></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label="Phone:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-form-input name="phone" v-model="contacts[1].phone" :formatter="phoneFormatter" required></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label="Job Title:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-form-input name="title" v-model="contacts[1].title"></b-form-input>
                                    </b-form-group>
                                </b-form-group>
                            </b-card>
                        </b-col>
                        </b-row>
                        <b-row>
                        <b-col>
                            <b-card bg-variant="light" class="my-2">
                                <h4>Warehouse / Shipping Contact</h4>
                                <b-form-group
                                    label-cols-lg="3"
                                    :label="contacts[2].position"
                                    label-size="lg"
                                    label-class="font-weight-bold pt-0"
                                    class="mb-0"
                                >
                                    <b-form-group
                                        label="First Name:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-form-input name="first_name" v-model="contacts[2].first_name" required></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Last Name:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-form-input name="last_name" v-model="contacts[2].last_name" required></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Email:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-form-input name="email" v-model="contacts[2].email" required></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label="Phone:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-form-input name="phone" v-model="contacts[2].phone" :formatter="phoneFormatter" required></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label="Job Title:"
                                        label-cols-sm="3"
                                        label-align-sm="right"
                                        class="my-1 py-0"
                                    >
                                        <b-form-input name="title" v-model="contacts[2].title"></b-form-input>
                                    </b-form-group>
                                </b-form-group>
                            </b-card>
                        </b-col>
                        </b-row>
                    </div>
                    <!-- Step Buttons -->
                    <div class="mt-4">
                        <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                            <b-button-group class="mx-1">
                                <b-btn @click="currentStep--">&lsaquo; Previous</b-btn>
                            </b-button-group>
                            <b-button-group class="ml-auto mx-1">
                                <b-btn type="submit" variant="primary">Next &rsaquo;</b-btn>
                            </b-button-group>
                        </b-button-toolbar>
                    </div>
                </b-form>

                <!-- ORDER FORM -->
                <b-form class="mt-5" v-show="shouldShowStep(3)" @submit.prevent="goToNextStep()">
                    <h3>Available Publications</h3>
                    <!-- TABLE -->
                    <b-alert variant="light" class="text-warning p-0" show>Please provide your best estimate of student enrollment counts needed by grade. <br/>Orders with student enrollment numbers outside of the allowable overage will be contacted by our support team before releasing the shipment</b-alert>
                    <b-table :fields="fields" :items="filteredPublications" bordered class="mb-0" striped>
                        <template #cell(grade)="data">
                            {{gradeNames[data.item.grade]}}
                        </template>
                        <template #cell(language)="data">
                            {{languageNames[data.item.language]}} <small>({{data.item.language}})</small>
                        </template>
                        <template #cell(teachers)="data">
                            <input type="number" min="0"  v-model="data.item.teachers" placeholder="# of Teachers">
                        </template>
                        <template #cell(students)="data">
                            <input type="number" min="0"  v-model="data.item.quantity" placeholder="# of Students">
                        </template>
                    </b-table>
                    <!-- Step Buttons-->
                    <div class="mt-4">
                        <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                            <b-button-group class="mx-1">
                                <b-btn @click="currentStep--">&lsaquo; Previous</b-btn>
                            </b-button-group>
                            <b-button-group class="ml-auto mx-1">
                                <b-btn type="submit" variant="primary">Review &rsaquo;</b-btn>
                            </b-button-group>
                        </b-button-toolbar>
                    </div>
                </b-form >

                <!-- ORDER SUMMARY -->
                <b-form class="my-5"  v-show="shouldShowStep(4)" v-if="publicationList" @submit.prevent="formSubmit()">
                    <div v-if="selectedCompany" class="mb-5">
                        <h4>{{ selectedCompany.name }}</h4>
                        <p>{{ selectedCompany.shipping_address }} {{ selectedCompany.city }}
                            ,{{ 'SD' }} ({{ selectedCompany.zip }})</p>
                    </div>
                    <h3>Order Summary:</h3>
                    <b-table :items="publicationList" :fields="productFields" small>
                        <template #cell(grade)="data">
                            {{gradeNames[data.item.grade]}}
                        </template>
                        <template #cell(language)="data">
                            {{languageNames[data.item.language]}} <small>({{data.item.language}})</small>
                        </template>
                        <template #cell(teachers)="data">
                            {{data.item.teachers}}
<!--                            <b-input type="number" v-model="data.item.teachers"></b-input>-->
                        </template>
                        <template #cell(students)="data">
                            {{data.item.quantity}}
<!--                            <b-input type="number" v-model="data.item.quantity"></b-input>-->
                        </template>
                    </b-table>
                    <div v-if="publicationList.length == 0" class="mb-3">
                        No Products Selected
                    </div>


                    <b-alert variant="light" class="text-danger ml-auto" show>{{validationMessage}}</b-alert>

                    <!-- Step Buttons -->
                    <div class="my-4">
                        <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                            <b-button-group class="mx-1">
                                <b-btn :disabled="isPostingOrder" @click="currentStep--">&lsaquo; Previous</b-btn>
                            </b-button-group>
                            <b-button-group class="ml-auto">
                                <b-btn :disabled="isPostingOrder" type="submit" variant="primary">Submit Order</b-btn>
                            </b-button-group>

                        </b-button-toolbar>
                    </div>

                    <!-- PD Advert -->
                    <div class="mt-5">
                        <h5 class="mt-5">Looking for help getting started?</h5>
                        <p>We offer a variety of customized PD delivery options to support your implementation. <br/>If you’d like to discuss our PD options, click here to request information from your rep.</p>
                        <b-btn variant="success" href="//www.studiesweekly.com/professional-development/" target="_blank">More info</b-btn>
                    </div>


                </b-form>

                <!-- SUBMIT BTN -->
                <div class="my-5">&nbsp;</div>
                <div class="my-5">&nbsp;</div>
                <div class="my-5">&nbsp;</div>
            </div>
        </b-container>

        <b-container class="my-5" v-show="invoiceId != null">
            <h2>Thank you!</h2>
            <h4>Your order has been submitted.</h4>
            <p>If you need to make any changes or adjustments, please contact our support team at <a href="mailto:orders@studiesweekly.com">orders@studiesweekly.com</a>.</p>
            <div><strong>Order Id</strong>: {{invoiceId}}</div>

            <!-- OrderDetails Summary -->
            <b-form class="my-5">
                <h3>Order Summary:</h3>
                <b-table :items="publicationList" :fields="productFields" small>
                    <template #cell(grade)="data">
                        {{gradeNames[data.item.grade]}}
                    </template>
                    <template #cell(language)="data">
                        {{languageNames[data.item.language]}} <small>({{data.item.language}})</small>
                    </template>
                    <template #cell(teachers)="data">
                        {{data.item.teachers}}
                        <!--                            <b-input type="number" v-model="data.item.teachers"></b-input>-->
                    </template>
                    <template #cell(students)="data">
                        {{data.item.quantity}}
                        <!--                            <b-input type="number" v-model="data.item.quantity"></b-input>-->
                    </template>
                </b-table>
            </b-form>
        </b-container>
        <b-navbar class="mt-5" fixed="bottom" toggleable="lg" style="color:white" variant="secondary">
            © 2025 Studies Weekly | All Rights Reserved
            <b-navbar-nav class="ml-auto">
                <zendesk-widget-button/>
            </b-navbar-nav>
        </b-navbar>
    </div>
</template>

<script>
import Vue from 'vue'
import {mapState} from "vuex";

import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

import moment from 'moment'
import sd_companies from "@/views/SDOrderForm/sd_companies";
import ZendeskWidgetButton from "@/components/ZendeskWidgetButton.vue";

Vue.use(require('vue-moment'))

export default {
    name: "SDOrderForm",
    components: {
        ZendeskWidgetButton,
        Calendar,
        DatePicker
    },
    data: () => ({

        // Steps
        stepsValid: [null, null, null, null, null],
        currentStep: 0,
        currentPage: 3,

        // Form Data
        publications: [],
        filteredPublications: [],

        // OrderDetails Data
        invoiceId: null,
        selectedCompany: null,
        selectedDistrict: null,
        selectedPrivate: null,
        multiyear: false,
        password: "",
        products: [],
        blackoutWindows: [],
        blackoutNoWindows: false,


        contacts: [{},{},{}],
        order: {
            "shipping": {
                "0": {
                    "address": null,
                    "city": null,
                    "first_name": null,
                    "last_name": null,
                    "email": null,
                    "state": null,
                    "zip": null,
                    "school": {
                        "id": null,
                    },
                    "products": []
                }
            },
            "shipping_details": {
                "school": {
                    "id": null,
                },
                "email": null,
                "school_year": null,
                "first_name": null,
                "last_name": null,
            },
            "billing": {
                "id": null,
                "first_name": null,
                "last_name": null,
                "email": null,
                "phone": null,
            },
            "products": [],
        },

        // Table Data
        languageNames: {
            en: 'English',
            es: 'Spanish'
        },
        gradeNames: {
            "-1": 'PreK',
            0: "K",
            1: "1st",
            2: "2nd",
            3: "3rd",
            4: "4th",
            5: "5th",
            6: "6th",
            7: "7th",
            8: "8th",
        },
        fields: [
            {key:'grade', sortable: false},
            // {key:'topic', sortable: true},
            // {key:'language', sortable: true},
            // {key:'sku', sortable: true},
            {key:'title', sortable: false},
            {key:'teachers', sortable: false},
            {key:'students', sortable: false},

            // {key:'actions', label: "Add", sortable: false}
        ],
        productFields: [
            {key:'grade', sortable: false},
            // {key:'topic', sortable: true},
            // {key:'language', sortable: true},
            // {key:'sku', sortable: true},
            {key:'title', sortable: false},
            {key:'teachers', sortable: false},
            {key:'students', sortable: false},
            // {key:'actions', label: "Remove", sortable: false},
        ],


        // View/Validation Fields
        validatingPassword: false,
        isPasswordChecked: false,
        password_message: "",
        arriveWindowRangeError: "",
        isPostingOrder: false,
        validationMessage: "",
    }),
    computed: {
        ...mapState({
            physicalProducts: state => state.stateData.physicalProducts,
        }),
        districts() { return sd_companies.filter((a) => a.is_public == 1); },
        privates() { return sd_companies.filter((a) => a.is_public == 0); },

        legacyIdSkus() {
            let skus = {};
            for (let i = 0; i < this.physicalProducts.length; ++i) {
                skus[this.physicalProducts[i].ID] = this.physicalProducts[i].sku;
            }
            return skus;
        },
        publicationList() {
            console.log(this.filteredPublications);
            let pubs = this.filteredPublications.filter(a => a.quantity > 0 && a.teachers >= 0)
            console.log(pubs);
            return pubs;
        },
    },
    methods: {
        async getProducts() {
            this.publications  = [
                {sku: 'SD0', grade: '0', title: 'South Dakota Studies Weekly: Introduction to America', legacy_id: 4794, id: 4794},
                {sku: 'SD1', grade: '1', title: 'South Dakota Studies Weekly: World to 315 and America 1492–1787', legacy_id: 4798, id: 4798},
                {sku: 'SD2', grade: '2', title: 'South Dakota Studies Weekly: World 315–1492 and America 1787–1908', legacy_id: 4802, id: 4802},
                {sku: 'SD3', grade: '3', title: 'South Dakota Studies Weekly: World to 60 B.C.E. and America 1492–1763', legacy_id: 4805, id: 4805},
                {sku: 'SD4', grade: '4', title: 'South Dakota Studies Weekly: World 60 B.C.E.–1300 and America 1763–1820', legacy_id: 4808, id: 4808},
                {sku: 'SD5', grade: '5', title: 'South Dakota Studies Weekly: World 1300–1648 and America 1820–1908', legacy_id: 4811, id: 4811},
            ];
            this.filteredPublications = this.publications;

            return;
            let response = await this.axios.get('/home/SD');
            this.publications = response.data.publications.filter((a) => a.topic == 'Social Studies');
            this.filteredPublications = this.publications;

            // console.log(response);
            // console.log(this.publications);
        },
        async getSchoolDistrictsForState() {
            return;
            let response = await this.$store.dispatch('listDistrictsByState', 'SD')

            if (!response)
                return;

            // Sort by name alphabetically
            response.data.sort((a, b) => {
                let aName = a.name.trim();
                let bName = b.name.trim();
                return (aName > bName) ? 1 : (aName < bName) ? -1 : 0
            })

            this.districts = response.data;
        },
        phoneFormatter(phoneVal, event) {
            // Replace template/mask parts
            let val = phoneVal.replaceAll(/[\(\)\- ]*/g, '');
            if (val === '')
                return '';

            // Get parts
            let parts = val.split('');
            let firstThree = parts.slice(0,3).join('');
            let secondThree = parts.slice(3,6).join('');
            let rest = parts.slice(6).join('');

            // Create masked value
            let template = `(${firstThree}`
            if (secondThree !== '')
                template += `) ${secondThree}`;
            if (rest !== '')
                template += `-${rest}`;
            return template;
        },
        formSubmit() {
            if (!this.validateForm()) {
                this.validationMessage = "A previous step is invalid. Please review and try again";
                return;
            }
            this.validationMessage = "";

            this.postOrder();
        },
        validateForm() {
            let isValid = this.validatePassword() && this.validateDistrict() && this.validateContacts() && this.validateOrder();
            this.$forceUpdate();
            return isValid;
        },
        checkPassword() {
            this.validatingPassword = true;
            this.axios.post('/checkout/orderformPass', {password: this.password})
                .then(() => {
                    this.setStepValid(0, true);
                    this.password_message = "";
                    this.validatingPassword = false;
                    this.isPasswordChecked = true;

                    setTimeout(() => {
                        this.goToNextStep();
                    }, 800);
                }).catch(() => {
                    this.setStepValid(0, false);
                    this.password_message = "incorrect password";
                    this.validatingPassword = false;
                    this.isPasswordChecked = true;
                });
        },
        validatePassword() {
            let isPasswordValid =  (this.password != null && this.password !== "" && this.isPasswordChecked);
            this.setStepValid(0, isPasswordValid);

            return isPasswordValid;
        },
        validateDistrict() {
            let isDistrictValid  = (
                this.selectedCompany != null
                && this.selectedCompany.id != null  && this.selectedCompany.id !== ""
                && this.selectedCompany.shipping_address != null  && this.selectedCompany.shipping_address !== ""
                && this.selectedCompany.city != null  && this.selectedCompany.city !== ""
                && this.selectedCompany.zip != null  && this.selectedCompany.zip !== ""
            );

            console.log(this.selectedCompany);
            console.log(isDistrictValid);
            if (this.blackoutWindows.length == 0 && !this.blackoutNoWindows) {
                isDistrictValid = false;
                this.arriveWindowRangeError = "If you have no dates that you are NOT available to receive shipments then please check 'I can receive shipments at any time'";
            }

            this.setStepValid(1, isDistrictValid);
            return isDistrictValid;
        },
        validateContacts() {
            let contactFormValid = true;
            for (let i = 0; i < this.contacts.length; ++i) {
                let contact = this.contacts[i];
                let isValidContact = (
                    (contact.first_name != null && contact.first_name != "")
                    && (contact.last_name != null && contact.last_name != "")
                    && (contact.email != null && contact.email != "")
                    && (contact.phone != null && contact.phone != "")
                );
                if (!isValidContact)
                    contactFormValid = false;
            }
            this.setStepValid(2, contactFormValid);
            return contactFormValid;
        },
        validateOrder() {
            let isOrderValid = (this.publicationList && this.publicationList.length > 0)
            this.setStepValid(3, isOrderValid);
            return isOrderValid;
        },

        setStepValid(stepNum, isValid) {
            this.stepsValid[stepNum] = isValid;
            this.$refs[`step${stepNum}_invalid`].style.display  = (isValid) ? "none" : "inline";
        },
        postOrder() {
            this.isPostingOrder = true;
            let products = this.publicationList;
            let data = {
                "multiyear": 1, // (this.multiyear) ? 6 : 1,
                "myo": 1, // Creates it as an adoption order
                // "payment_method": "SD_ORDER",
                "payment_method": "purchase_order",
                "sw_email": "southdakota@studiesweekly.com",
                "password": this.password,
                "year": 2027,
                "contacts": this.contacts,
                "blackout_windows": this.mergeWindows(),
                "ship_anytime": this.blackoutNoWindows,
                "exempt_from_invoicing": 1,
                "shipping": {
                    "0": {
                        "address": this.selectedCompany.shipping_address,
                        "city": this.selectedCompany.city,
                        "zip": this.selectedCompany.zip,
                        "state": 'SD',
                        "first_name": this.contacts[2].first_name,
                        "last_name": this.contacts[2].last_name,
                        "email": this.contacts[2].email,
                        "school": {
                            "id": this.selectedCompany.id,
                        },
                        "products": products,
                    }
                },
                "shipping_details": {
                    "school": {
                        "id": this.selectedCompany.id,
                        "name": this.selectedCompany.name,
                        "address": this.selectedCompany.shipping_address,
                        "city": this.selectedCompany.city,
                        "zip": this.selectedCompany.zip,
                        "state": 'SD',
                    },
                    "email": this.contacts[2].email,
                    "phone": this.contacts[2].phone,
                    "school_year": 2026, // TODO: hard coded year
                    "first_name": this.contacts[2].first_name,
                    "last_name": this.contacts[2].last_name,
                    "canShipPartial": false,
                    "cantShipPartial": true,
                },
                "billing": {
                    "id": this.selectedCompany.id,
                    "first_name": this.contacts[0].first_name,
                    "last_name": this.contacts[0].last_name,
                    "email": this.contacts[0].email,
                    "phone": this.contacts[0].phone,
                    "purchase_order": "south-dakota-26"
                },
                "products": products,
            };
            this.axios.post('/checkout/orderform', data)
            .then(response => {
                console.log(response);
                if (response.data && response.data.id)
                    this.invoiceId = response.data.id;
            })
            .catch((error) => {
                if (error.response.status == 401) {
                    this.$swal({
                        toast: true,
                        html: 'Incorrect Password.',
                        type: 'error',
                        position: 'top-end',
                        showConfirmButton: false,
                        noAutoHide: true
                    });
                    this.setStepValid(0, false);
                    this.$forceUpdate();
                    return;
                }
                this.$swal({
                    toast: true,
                    html: `We encountered an unexpected error. <br/>
                       <strong>Error</strong>: ${error.message}`,
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    noAutoHide: true
                })
            })
            .finally(() => {
                this.isPostingOrder = false;
            })
        },
        getStepVariant(stepNum) {
            if (this.currentStep == stepNum)
                return 'primary';

            if (this.stepsValid[stepNum] === null)
                return 'secondary';

            if (this.stepsValid[stepNum] === true)
                return 'success';

            return 'danger';
        },
        shouldShowStep(index) {
            return this.currentStep == index;
        },
        setStep(stepNum) {
            this.currentStep = stepNum;
            switch (this.currentStep) {
                case 3: this.validateOrder();
                case 2: this.validateContacts();
                case 1: this.validateDistrict();
                case 0: this.validatePassword(); break;
            }
            this.$forceUpdate();
        },
        goToNextStep() {
            this.validationMessage = "";
            let isValid = true;
            switch (this.currentStep) {
                case 3: isValid = isValid && this.validateOrder();
                case 2: isValid = isValid && this.validateContacts();
                case 1: isValid = isValid && this.validateDistrict();
                case 0: isValid = isValid && this.validatePassword(); break;
            }
            this.$forceUpdate();

            if (!isValid)
                return;

            this.currentStep++;
        },
        // BLACKOUT WINDOWS, TODO: make this a component?
        mergeWindows() {
            if (this.blackoutWindows.length === 0 || this.blackoutNoWindows)
                return [];

            let finalWindows = [];
            let windows = JSON.parse(JSON.stringify(this.blackoutWindows));
            // Sort by date ASC
            windows.sort((a, b) => {
                return new Date(a.start) - new Date(b.start);
            });

            // Check each window against the others, todo: figure out new algo for this.
            for (let i = 0; i < windows.length; ++i) {
                if (!windows[i].start || !windows[i].end)
                    continue;

                const windowA = windows[i];
                let newWindow = {start: new Date(windowA.start), end: new Date(windowA.end)};

                // Compare each date against the current window
                for (let j = 0; j < windows.length; ++j) {
                    if (j === i)
                        continue;

                    let windowB = {start: new Date(windows[j].start), end: new Date(windows[j].end)};

                    // A is not before B
                    if (newWindow.end > windowB.end)
                        continue;

                    // Date Diffs
                    const endToStartDiff = newWindow.end - windowB.start;
                    const endToStartDays = endToStartDiff / (1000 * 64 * 64 * 24);

                    // B is withing 2 weeks of A
                    if (endToStartDays > -13) {
                        newWindow.end = windowB.end;
                        windows.splice(j,1);
                        j--;
                    }
                }
                windows[i] = newWindow;
                finalWindows.push(newWindow);
            }
            return finalWindows;
        },
        addWindow() {
            this.blackoutWindows.push({start: null, end: null});
        },
        deleteWindow(i) {
            this.blackoutWindows.splice(i, 1);
        },
        toggleWindow(i) {
            let el =  this.$refs[`blackoutWindow_${i}`][0].$el;
            if (el.style.display !== 'none') {
                el.style = 'display: none';
                return;
            }
            el.style = 'display: block';
        },
        getDisabledDates(i) {
            // Get all items in blackoutWindows except the current (i-th) element
            return this.blackoutWindows.filter((element, index) => {
                return index !== i;
            });
        },
        dateRangeText(dateRange) {
            if (!dateRange || !dateRange.end)
                return null;

            let startDate = new Date(dateRange.start).toLocaleDateString('en-US');
            let endDate = new Date(dateRange.end).toLocaleDateString('en-US');

            return `${startDate} ~ ${endDate}`;
        },
        validateRange (event, windowIndex) {
            if (!event || !event.start) return;

            var windowStart = moment(event.start);
            var windowEnd = moment(event.end);
            this.arriveWindowRangeError = null;

            // Hide datepicker
            this.$refs[`blackoutWindow_${windowIndex}`][0].$el.style = 'display: none;';
        },
        // End blackout window functions
    },
    watch: {
        password() {
            // this.passwordDebounce();
        },
        selectedDistrict(newVal, oldVal) {
            if (!newVal)
                return;
            this.selectedCompany = newVal;
            this.selectedPrivate = null;
        },
        selectedPrivate(newVal, oldVal) {
            if (!newVal)
                return;
            this.selectedCompany = newVal;
            this.selectedDistrict = null;
        }
    },
    created() {
        this.getSchoolDistrictsForState();
        this.getProducts();

    },
    mounted() {
    }
}
</script>

<style scoped>
.collapsed > .when-open,
.not-collapsed > .when-closed {
    display: none;
}
#district_info .form-group {
    width: 50%;
    padding: 0px 5px 0 5px;
    margin-bottom: 7px;
}
.pill-validator {
    color:black;
    position: relative;
    /*top: -15px;*/
    /*right: -5px;*/
    display: none;
}

.loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    border-bottom: 16px solid #3498db;
    width: 25px;
    height: 25px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
}
@-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>